<template>
  <div class="main">
    <div v-if="loading" class="loading-overlay">
      <div class="loading-gif"></div>
    </div>
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/home"><img :src="icBack" /></router-link>
        <span>Boletos</span>
        <router-link to="/home"><img :src="icClose" /></router-link>
      </div>
      <div class="content">
        <p>
          Informe a linha digitável ou utilize o leitor de código de barras.
        </p>
        <input id="typeful" type="input" placeholder="Linha Digitavel" v-model="linhaDigitavel" @click="toggleKeyboard"
          :class="{ disabled: isInputDisabled }" />
        <virtual-keyboard v-if="isKeyboardOpen" @key-click="handleKeyClick" @close-keyboard="closeKeyboard"
          @delete-click="handleDeleteClick"></virtual-keyboard>
        <a href="#" @click.prevent="consultaBoleto">
          <img :src="next" class="nextStep" :class="{ disabled: !isCodeBarFilled }" />
        </a>
      </div>
      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import icBack from '@/assets/svg/ic-back.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icNext from '@/assets/svg/ic-next.svg'
import FooterGlobal from '@/components/Footer.vue'
import VirtualKeyboard from '@/components/VirtualKeyboard.vue'
import axios from 'axios'
import { timerToReturnToHome } from '@/helper/timer'

export default defineComponent({
  name: 'BoletoPage',
  components: {
    FooterGlobal,
    VirtualKeyboard,
  },
  data() {
    timerToReturnToHome(40000)
    onMounted(() => {
      this.router = useRouter()
      let el = document.getElementById('typeful')
      el.focus()
      this.toggleKeyboard()
    })

    return {
      icBack: icBack,
      icClose: icClose,
      next: icNext,
      isKeyboardOpen: false,
      isInputDisabled: false,
      linhaDigitavel: '',
      codeBar: '',
      loading: false,
      router: null,
    }
  },
  computed: {
    isCodeBarFilled() {
      return (
        (this.linhaDigitavel.replaceAll(' ', '').replaceAll('.', '').length === 44) ||
        (this.linhaDigitavel.replaceAll(' ', '').replaceAll('.', '').length === 47) ||
        (this.linhaDigitavel.replaceAll(' ', '').replaceAll('.', '').length === 48)
      );
    },
  },
  methods: {
    handleKeyClick(key) {
      if (key === 'backspace') {
        this.linhaDigitavel = this.linhaDigitavel.slice(0, -1)
      } else {
        this.linhaDigitavel += key
      }
    },
    handleDeleteClick() {
      if (this.linhaDigitavel.length > 0) {
        this.linhaDigitavel = this.linhaDigitavel.slice(0, -1)
      }
    },
    toggleKeyboard() {
      this.isKeyboardOpen = !this.isKeyboardOpen
      this.isInputDisabled = this.isKeyboardOpen
    },
    closeKeyboard() {
      this.isKeyboardOpen = false
      this.isInputDisabled = false
    },
    async consultaBoleto() {
      this.loading = true

      const username = process.env.VUE_APP_IPAG_API_USER
      const password = process.env.VUE_APP_IPAG_API_PASSWORD
      const url = process.env.VUE_APP_API_URL
      const basicAuth = btoa(`${username}:${password}`)

      const codigoLimpo = this.linhaDigitavel.replaceAll(' ', '').replaceAll('.', '')

      try {
        const response = await axios.post(
          `${url}/totem/boletoPagamentoConsulta.php`,
          {
            codigoBarras: codigoLimpo.length === 44 ? codigoLimpo : '',
            linhaDigitavel: codigoLimpo.length === 47 || codigoLimpo.length === 48
              ? codigoLimpo : '',
          },
          {
            headers: {
              Authorization: `Basic ${basicAuth}`,
              'Content-Type': 'application/json',
            },
          },
        )

        this.loading = false

        if (response.data.status === false && response.data.HTTPCODE === 400) {
          const mensagem =
            response.data?.dados?.dados?._errors?.[0]?._message ||
            response.data?.motivoCritica ||
            'Erro ao consultar boleto.'

          this.$router.push({
            path: '/erro',
            query: { mensagem },
          })
          return
        }

        if (response.data.dados) {
          sessionStorage.setItem('dadosBoleto', JSON.stringify(response.data.dados))
          this.$router.push('/boleto/info-boleto')
        }
      } catch (error) {
        this.loading = false

        if (error.response && error.response.status === 400) {
          const data = error.response.data

          const mensagem =
            data?.dados?.dados?._errors?.[0]?._message ||
            data?.motivoCritica ||
            data?.dados?._message ||
            'Erro ao consultar boleto.'

          this.$router.push({
            path: '/erro',
            query: { mensagem },
          })
          return
        }

        this.$router.push({
          path: '/erro',
          query: { mensagem: 'Erro ao consultar boleto. Tente novamente.' },
        })
      }
    },
  },
})
</script>
